export default __webpack_public_path__ + "static/media/forever-saves.3cca26fa.svg";